/**
 * register plugins
 */

export default (
  element: Element | Document,
  event: string,
  detail: any = null
): void =>
  void element.dispatchEvent(
    new (detail ? CustomEvent : Event)(event, {
      bubbles: true,
      cancelable: true,
      detail,
    })
  )
